import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { Router } from '@angular/router';
import { Medico } from '../../medico/medico';
import { MedicoService } from '../../medico/medico.service';
import { Horario } from '../../util/hora-atendimeno';
import { Util } from '../../util/util';
import { FaltaMedica } from '../falta-medica';
import { FaltaMedicaService } from '../falta-medica.service';

@Component({
  selector: 'app-falta-medica-maintenance',
  templateUrl: './falta-medica-maintenance.component.html',
  styleUrls: ['./falta-medica-maintenance.component.css'],
})
export class FaltaMedicaMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo: boolean = false;

  faltaMedica: FaltaMedica;

  formularioFaltaMedica: FormGroup;

  tituloCrud: string = '';

  public listaHorarios: Horario[];

  public listaMedicos: Medico[];

  constructor(private faltaMedicaService: FaltaMedicaService,
    private medicoService: MedicoService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.faltaMedica = new FaltaMedica();

    this.formularioFaltaMedica = this.formBuilder.group({
      id: 0,
      medico: ['', [Validators.required]],
      dataFalta: ['', [Validators.required]],
      horaFalta: [''],
      tipoDeFalta: [''],
      motivoFalta: ['', [Validators.required]]
    });

    this.listaHorarios = Util.listaHorasAtendimentos;

    this.listaMedicos = [];
  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Falta Médica';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Falta Médica';
      }
    } else {
      this.tituloCrud = 'Criar Falta Médica';
    }

    this.listarMedicos();
  }

  save() {

    this.faltaMedica = this.formularioFaltaMedica.value;

    this.configureTipoFaltaMedica(this.formularioFaltaMedica.controls.tipoDeFalta.value);

    if (this.isNew()) {
      this.faltaMedicaService
        .criar(this.faltaMedica).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.faltaMedicaService.atualizar(this.faltaMedica, this.id)
        .subscribe(data => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/faltaMedica']);
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioFaltaMedica.controls;
  }

  listarMedicos() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.listaMedicos = data;

        this.configurarForm();
      }, error => {
        console.log(error);
      });
  }

  configurarForm(): void {
    if (!this.isNew()) {
      this.faltaMedicaService.procurarPorId(this.id)
        .subscribe(data => {
          // console.log(data)

          this.faltaMedica = Object.assign(new FaltaMedica(), data);

          //this.formularioFaltaMedica.setValue(this.faltaMedica);

          // Configurar Medico
          let currentMedico = this.listaMedicos.filter(med => med.id == this.faltaMedica.medico.id)[0];
          this.formularioFaltaMedica.controls.medico.patchValue(currentMedico);

          // Configurar Tipo de Falta
          if (this.faltaMedica.faltaDiaInteiro) {

            this.formularioFaltaMedica.controls.tipoDeFalta.setValue('DI');
            this.formularioFaltaMedica.controls.horaFalta.disable();

          } else if (this.faltaMedica.faltaPeriodoManha) {

            this.formularioFaltaMedica.controls.tipoDeFalta.setValue('M');
            this.formularioFaltaMedica.controls.horaFalta.disable();

          } else if (this.faltaMedica.faltaPeriodoTarde) {

            this.formularioFaltaMedica.controls.horaFalta.disable();
            this.formularioFaltaMedica.controls.tipoDeFalta.setValue('T');

          }

          //Configurar Data da Falta
          this.formularioFaltaMedica.controls.dataFalta.setValue(
            new Date(this.faltaMedica.dataFalta.toString().replace('-', '/')));

          // Configurar Hora da Falta
          if (this.faltaMedica.horaFalta) {
            let currentHoraFalta = this.listaHorarios.filter(hor => hor.codigo.toString() === this.faltaMedica.horaFalta)[0];
            this.formularioFaltaMedica.controls.horaFalta.patchValue(currentHoraFalta.codigo);
          }

          // Configurar Motivo da Falta
          this.formularioFaltaMedica.controls.motivoFalta.setValue(this.faltaMedica.motivoFalta);

          this.cd.detectChanges();

          if (this.isUpdate == 'N') {
            this.formularioFaltaMedica.disable();
          }
        }, error => {
          console.log(error);
        });
    } else {
      this.formularioFaltaMedica.setValue({
        id: 0,
        medico: '',
        dataFalta: '',
        horaFalta: '',
        tipoDeFalta: '',
        motivoFalta: '',
      });
    }
  }

  onTipoDeFaltaChange(event: MatRadioChange): void {

    if (event && event.value) {

      this.formularioFaltaMedica.controls.horaFalta.setValue(null);
      this.formularioFaltaMedica.controls.horaFalta.patchValue(null);
      this.formularioFaltaMedica.controls.horaFalta.disable();

      this.configureTipoFaltaMedica(event.value);
    }
  }

  configureTipoFaltaMedica(tipoFalta: string): void {
    if (tipoFalta === 'DI') {

      this.faltaMedica.faltaDiaInteiro = true;
      this.faltaMedica.faltaPeriodoManha = false;
      this.faltaMedica.faltaPeriodoTarde = false;

    } else if (tipoFalta === 'M') {

      this.faltaMedica.faltaDiaInteiro = false;
      this.faltaMedica.faltaPeriodoManha = true;
      this.faltaMedica.faltaPeriodoTarde = false;

    } else if (tipoFalta === 'T') {

      this.faltaMedica.faltaDiaInteiro = false;
      this.faltaMedica.faltaPeriodoManha = false;
      this.faltaMedica.faltaPeriodoTarde = true;

    }

  }
}
